const WIDTH_SP = 768;

let introStackUpdate = null;

(() => {

  // 初期化処理
  const init = () => {
    const body = document.querySelector('body');
    body.style.opacity = "1";
    body.classList.remove('preload');

    // 各初期化関数の呼び出し
    initSmoothScroll();
    initIsOn();
    doFade();
    initSlider();
    //initIntroStack();
    updateEndingImageSubOn();
  };

  // リサイズイベント処理
  let resizeTimeout;
  const handleResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (typeof introStackUpdate === 'function') {
        introStackUpdate();
      }
      updateEndingImageSubOn();
    }, 200);
  };

  // スクロールイベント処理
  let lastScrollTime = 0;
  const handleScroll = () => {
    const now = Date.now();
    if (now - lastScrollTime >= 100) {
      doFade();
      initIsOn();
      lastScrollTime = now;
    }
  };

  let endingImageSubRaf = null;
  const scheduleEndingImageSubOn = () => {
    if (endingImageSubRaf) return;
    endingImageSubRaf = requestAnimationFrame(() => {
      endingImageSubRaf = null;
      updateEndingImageSubOn();
    });
  };

  // イベントリスナーの登録
  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('resize', handleResize);
  window.addEventListener('scroll', handleScroll);
  window.addEventListener('scroll', scheduleEndingImageSubOn, { passive: true });
  
})();

const isLegacy = () => {
  const ua = window.navigator.userAgent || '';
  if (!/iP(hone|od|ad)/.test(ua)) return false;
  const m = ua.match(/OS (\d+)_/);
  if (!m) return false;
  const major = parseInt(m[1], 10);
  return Number.isFinite(major) && major <= 12;
};

const isIOS = () => /iP(hone|od|ad)/.test(window.navigator.userAgent || '');


// スムーススクロール
const initSmoothScroll = () => {
  document.querySelectorAll('a[href^="#"]').forEach(trigger => {
    trigger.addEventListener('click', e => {
      e.preventDefault();
      const targetId = trigger.getAttribute('href').replace('#', '');
      const targetElement = document.getElementById(targetId);
      if (targetElement) adjustScrollPosition(targetElement, 'smooth');
    });
  });
};

const adjustScrollPosition = (targetElement, behavior = 'smooth') => {
  const rect = targetElement.getBoundingClientRect().top;
  const offset = window.pageYOffset;
  const headerEl = document.getElementById('header');
  const headerH = headerEl ? headerEl.clientHeight : 0;
  const gap = headerH || 80;
  const target = rect + offset - gap;

  window.scrollTo({ top: target, behavior });
};

// スクロールでis-onクラスを付与
const initIsOn = () => {
  document.querySelectorAll('.js-scroll').forEach(elem => {
    const rect = elem.getBoundingClientRect().top;
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const offset = rect + scroll;
    const windowHeight = window.innerHeight;

    const isLoad = elem.dataset.load !== undefined;
    const dispPosition = offset - windowHeight;

    if (scroll > dispPosition || isLoad) {
      elem.classList.add('is-on');
    } else {
      elem.classList.remove('is-on');
    }
  });
};


// 要素のフェード
const doFade = () => {
  document.querySelectorAll('.js-fade-in').forEach(elem => {
    const rect = elem.getBoundingClientRect().top;
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const offset = rect + scroll;
    const windowHeight = window.innerHeight;
    const delay = parseFloat(elem.dataset.delay) || 0;
    const isLoad = elem.dataset.load !== undefined;
    const positionPc = parseFloat(elem.dataset.positionPc) || 200;
    const positionSp = parseFloat(elem.dataset.positionSp) || 0;
    const position = document.body.clientWidth > WIDTH_SP ? positionPc : positionSp;
    const dispPosition = offset - windowHeight + position;
    const duration = parseFloat(elem.dataset.duration) || 1.5;

    if (scroll > dispPosition || isLoad) {
      elem.classList.add('js-scroll-in');
      elem.style.transitionDelay = `${delay}s`;
      elem.style.transitionDuration = `${duration}s`;
    }
  });
};

// intro：同一位置で1枚ずつ表示する
const initIntroStack = () => {

  const root = document.querySelector('.js-intro-stack');

  if (!root) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  const panels = root.querySelectorAll('.intro__content');
  const n = panels.length;
  if (n === 0) return;

  if (isLegacy()) {
    root.style.height = 'auto';
    root.style.setProperty('--intro-slide-count', 'auto');

    const stage = root.querySelector('.intro__stage');
    if (stage) {
      stage.style.position = 'static';
      stage.style.height = 'auto';
      stage.style.maxHeight = 'none';
      stage.style.overflow = 'visible';
    }

    panels.forEach((panel) => {
      panel.style.position = 'relative';
      panel.style.opacity = '1';
      panel.style.pointerEvents = 'auto';
      panel.style.height = 'auto';
    });
    return;
  }

  root.style.setProperty('--intro-slide-count', String(n));

  let displayK = null;
  let lastStepTime = 0;
  let lastVh = null;
  // 替えまでの最短間隔。大きいほど飛びにくい。その代わり切り替わりもゆっくりになる。
  const MIN_STEP_MS = 400;
  let chaseRaf = null;

  const applyPanels = (k) => {
    panels.forEach((panel, i) => {
      const isActive = i === k;
      panel.style.opacity = isActive ? '1' : '0';
      panel.style.zIndex = isActive ? '1' : '0';
    });
  };

  const update = () => {
    const vh = Math.max(window.innerHeight, 1);
    const scrollY = window.pageYOffset || document.documentElement.scrollTop;
    const rootTop = root.getBoundingClientRect().top + scrollY;
    let rel = scrollY - rootTop;
    if (rel < 0) rel = 0;

    if (!isIOS() && displayK !== null) {
      const introMaxRel = Math.max(0, root.offsetHeight - vh);
      const minRel = displayK > 0 ? (displayK - 1) * vh : 0;
      const maxRel =
        displayK < n - 1
          ? Math.min((displayK + 1) * vh, introMaxRel)
          : Number.POSITIVE_INFINITY;
      const eps = 1;
      if (rel < minRel - eps || rel > maxRel + eps) {
        const nextRel = Math.min(Math.max(rel, minRel), maxRel);
        window.scrollTo({
          left: 0,
          top: rootTop + nextRel,
          behavior: 'auto',
        });
        rel = nextRel;
      }
    }

    const targetK = Math.min(Math.floor(rel / vh), n - 1);
    const now = performance.now();

    if (lastVh !== null && lastVh !== vh) {
      displayK = null;
    }
    lastVh = vh;

    if (displayK === null) {
      displayK = targetK;
      lastStepTime = now;
    } else if (displayK !== targetK) {
      if (now - lastStepTime >= MIN_STEP_MS) {
        displayK += Math.sign(targetK - displayK);
        lastStepTime = now;
      }
    }

    applyPanels(displayK);

    if (displayK !== targetK) {
      if (!chaseRaf) {
        chaseRaf = requestAnimationFrame(() => {
          chaseRaf = null;
          update();
        });
      }
    }
  };

  introStackUpdate = update;

  let raf = null;
  const schedule = () => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = null;
      update();
    });
  };

  update();
  window.addEventListener('scroll', schedule, { passive: true });
};

// スライダーのセット
const initSlider = () => {

  const mvEl = document.querySelector('.mv-swiper');
  if (!mvEl) return;

  new Swiper(mvEl, {
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    speed: 800,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
  });

  // ラインナップ
  const lineupSwiper = new Swiper('.lineup-swiper', {
    loop: true, // 無限ループ
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: { delay: 3000 },
    speed: 600,  
  });

};
